<div
  class="fullscreen-dialog flex column"
  tabindex="0"
  [cdkTrapFocus]="true"
  [cdkTrapFocusAutoCapture]="true"
>
  <div class="fullscreen-dialog__header flex justify--space-between">
    <sui-button color="neutral" variant="ghost" (click)="dismiss()">
      {{ 'global.close' | translate }}
    </sui-button>
    <ng-content select="action"></ng-content>
  </div>
  <div class="fullscreen-dialog__body flex justify--center">
    <div class="content flex column">
      <div class="header flex column">
        <div class="title">{{ title() | translate }}</div>
        <div class="subtitle">{{ subtitle() | translate }}</div>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
